import { LoadableAfterPaint } from '@confluence/loadable';

import { CommentButtonPlaceholder } from '../src/CommentButtonPlaceholder.tsx';
export { getPlacement } from '../src/CommentButton.tsx';

export const CommentButton = LoadableAfterPaint({
	loader: async () =>
		(await import(/* webpackChunkName: "loadable-CommentButton" */ '../src/CommentButton.tsx'))
			.CommentButton,
	loading: CommentButtonPlaceholder as any,
});
